import Box from '@mui/material/Box'
import MuiModal from '@mui/material/Modal'
import { styled } from '@mui/material/styles'
import { ReactNode } from 'react'
import Body from './Body'
import Footer from './Footer'
import Header from './Header'

interface Props {
  open: boolean
  onClose: () => void
  children: ReactNode
}

const Modal = ({ open, onClose, children }: Props) => {
  return (
    <MuiModal open={open} onClose={onClose} aria-labelledby="modal">
      <Container>{children}</Container>
    </MuiModal>
  )
}

const Container = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  background-color: white;
  border-radius: 4px;
  overflow: hidden;
`

Modal.Header = Header
Modal.Body = Body
Modal.Footer = Footer

export default Modal
